import type { PropsWithChildren } from "react";
import { SITE_THEMES } from "@/react/components/shared/BuilderUI/SiteThemes/constants";
import { BuilderUI } from "@circle-react-shared/BuilderUI";
import { defaultBlocks } from "@circle-react-shared/BuilderUI/DefaultBlocks";
import { defaultData as mockRootBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/Root/RootDefaultData";

export const BuilderWrapper = ({
  children,
}: PropsWithChildren<Record<string, unknown>>) => (
  <BuilderUI.Provider
    // Check in later PRs if we need these presets
    theme={SITE_THEMES.defaultTheme}
    block={mockRootBlock}
    blockMapping={defaultBlocks}
    canvasSize="desktop"
  >
    <BuilderUI.Shell>{children}</BuilderUI.Shell>
  </BuilderUI.Provider>
);
